module.exports = __webpack_public_path__ + "static/media/NeedInfo.2b372c7d.svg";